<template>
  <div class="landingpage">
    <router-link to="/login/connexion" class="blue">CONNEXION</router-link>
    <router-link to="/login/inscription" class="blue">UTILISER UN CODE</router-link>
  </div>
</template>

<script>
import {store} from "../store/store";

export default {
  name: 'connexion',
  data() {
    return {}
  },
  methods: {},
}
</script>

<style scoped>

.landingpage {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100vh;
  background: no-repeat center/cover url('/assets/background.png') #fff;
}

@media screen and (min-width: 780px) {
  .landingpage {
    background: no-repeat center/cover url('/assets/web_background.png') #fff;

  }

  .landingpage .blue {
    width: 30%;
  }
}

.blue:first-child {
  margin-bottom: 20px;
}

.blue:last-child {
  margin-top: 20px;
}

.blue {
  padding: 10px;
  border-radius: 10px;
  font-family: var(--main-title-font);
  font-size: 26px;
  width: 70%;
  text-align: center;
  border: 2px solid #FFF;
  font-weight: bold;
  background: linear-gradient(#00CDF8, #00ABDD);
  transition: .3s;
}

.blue:hover {
  color: #00CDF8;
  border: 2px solid #00CDF8;

  background: #fff;

}


</style>
